import script from "./BrowseByBody.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseByBody.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__